import {Input, SwitchField} from '@eitje/web_components'
import {Select} from '~/components'
import {DISCOUNT_ITEMS} from './constants'
import {useFieldValue} from '@eitje/form'

export const FormFields = () => {
	const discount = useFieldValue('discount')

	const hasDiscount = discount !== 'no_discount'
	const discountItem = DISCOUNT_ITEMS.find(({id}) => id === discount)

	const noteFieldProps = {
		field: 'note',
		textarea: true,
		infoIconMessage: {body: 'tooltips.price_agreements.note'},
	}

	return (
		<>
			<Input {...noteFieldProps} required={hasDiscount} />
			<Select field="discount" items={DISCOUNT_ITEMS} clearIcon={false} />
			{hasDiscount && <Input field={discount} required validate={discountItem.validate} />}
			<SwitchField field="ignore_mollie" infoIconMessage={{body: 'tooltips.ignore_mollie'}} />
			<Input field="vat_number" />
		</>
	)
}
